(() => {
  const initRelicsHomepage = () => {
    const hero = document.querySelector('[data-relics-home-hero]');
    const header = document.getElementById('shopify-section-header');
    const announcement = document.getElementById('shopify-section-announcement-bar');

    if (!hero || !header) return;

  

    const measure = () => {
      const announcementHeight = announcement && announcement.offsetParent !== null
        ? announcement.getBoundingClientRect().height
        : 0;
      document.body.style.setProperty('--relics-announcement-height', `${announcementHeight}px`);
    };

    const update = () => {
      document.body.classList.toggle('relics-header-solid', window.scrollY > 50);
    };

    measure();
    update();

    if (!window.__relicsHomepageBound) {
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', measure, { passive: true });
      window.__relicsHomepageBound = true;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRelicsHomepage);
  } else {
    initRelicsHomepage();
  }

  document.addEventListener('shopify:section:load', initRelicsHomepage);
  document.addEventListener('shopify:section:reorder', initRelicsHomepage);
})();
